import { css } from '@emotion/react';

export * from '../filter-headings.style';

export const textInput = css`
  padding: 14px 14px;
`;
